module.exports = __webpack_public_path__ + "static/impact-mobile-title-54bd85de26c786187f8789b53172fef4.svg";